import { userRoles } from '@constants/common';

export const LoadTendersRoute = {
  path: '/load/tenders',
  load: () => import('./LoadTenders'),
  protected: true,
  blacklistedRoles: [userRoles.CAPACITY],
};
